import { SubTopicObject } from "assets/data/topics";
import { TopicsComponent } from "components";
import FeedLayout from "layouts/files/FeedLayout";
import { useDispatch, useSelector } from "react-redux";
import { addTopic, removeTopic } from "services/redux/settings/account";
import { AppDispatch, RootState } from "services/redux/store";
import { customToaster } from "ui";

const Topics = () => {
    const selectedTopics = useSelector(
        (state: RootState) => state.account.selectedTopics
    );
    const mode = useSelector((state: RootState) => state.site.mode);
    const dispatch = useDispatch<AppDispatch>();

    const toggleTopic = (t: SubTopicObject) => {
        if (selectedTopics.some((i) => i.SubTopicId == t.SubTopicId)) {
            if (selectedTopics.length == 1) {
                // show toast
                customToaster(
                    "error",
                    "You must select at least 1 topic",
                    mode
                );
            }
            dispatch(removeTopic(t));
        } else {
            dispatch(addTopic(t));
        }
    };

    return (
        <FeedLayout pageTitle="Topics">
            <TopicsComponent
                isPage
                selectedTopics={selectedTopics}
                toggleTopic={toggleTopic}
            />
        </FeedLayout>
    );
};

export default Topics;
